import { render, staticRenderFns } from "./AddLeadOwner.vue?vue&type=template&id=3fbc7c48&scoped=true"
import script from "./AddLeadOwner.vue?vue&type=script&lang=js"
export * from "./AddLeadOwner.vue?vue&type=script&lang=js"
import style0 from "./AddLeadOwner.vue?vue&type=style&index=0&id=3fbc7c48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbc7c48",
  null
  
)

export default component.exports